exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-165e9ba6]{position:relative}img[data-v-165e9ba6]{top:0;left:0;width:100%;height:100%;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;cursor:pointer}img[data-v-165e9ba6],svg[data-v-165e9ba6]{position:absolute}svg[data-v-165e9ba6]{width:80px;height:80px;left:50%;top:50%;margin:-40px;pointer-events:none}.length[data-v-165e9ba6]{position:absolute;background:#b4c3b9;color:#fff!important;padding:3px 6px;line-height:1;right:0;bottom:0}", ""]);

// exports
